import { createApp } from 'vue';
import Scrollbars from './modules/Scrollbars';
import ViewportHeight from './modules/ViewportHeight';

import Header from '@/components/Header.vue';

import FilterGrid from '@/components/modules/FilterGrid.vue';
import Media from '@/components/elements/Media.vue';
import Gallery from '@/components/elements/Gallery.vue';
import VideoEmbed from '@/components/elements/VideoEmbed.vue';
import Carousel from '@/components/modules/Carousel.vue';
import Accordion from '@/components/modules/Accordion.vue';
import ContactLink from '@/components/elements/ContactLink.vue';
import Breadcrumbs from '@/components/elements/Breadcrumbs.vue';

import DevGrid from '@/components/DevGrid.vue';


const header = document.querySelector('#app-header');

const filtergrids = document.querySelectorAll('.app-filtergrid');
const medias = document.querySelectorAll('.app-media');
const galleries = document.querySelectorAll('.app-gallery');
const videos = document.querySelectorAll('.app-video');
const carousels = document.querySelectorAll('.app-carousel');
const accordions = document.querySelectorAll('.app-accordion');
const contactlinks = document.querySelectorAll('.app-contactlink');
const breadcrumbs = document.querySelectorAll('.app-breadcrumbs');

const devgrid = document.querySelector('#app-devgrid');


Scrollbars();
ViewportHeight();


if (header) {
    createApp(Header, {...header.dataset}).mount(header);
}

if (filtergrids) {
    filtergrids.forEach((filtergrid) => {
        createApp(FilterGrid, {...filtergrid.dataset}).mount(filtergrid);
    });
}
if (medias) {
    medias.forEach((media) => {
        createApp(Media, {...media.dataset}).mount(media);
    });
}
if (galleries) {
    galleries.forEach((gallery) => {
        createApp(Gallery, {...gallery.dataset}).mount(gallery);
    });
}
if (videos) {
    videos.forEach((video) => {
        createApp(VideoEmbed, {...video.dataset}).mount(video);
    });
}
if (carousels) {
    carousels.forEach((carousel) => {
        createApp(Carousel, {...carousel.dataset}).mount(carousel);
    });
}
if (accordions) {
    accordions.forEach((accordion) => {
        createApp(Accordion, {...accordion.dataset}).mount(accordion);
    });
}
if (contactlinks) {
    contactlinks.forEach((contactlink) => {
        createApp(ContactLink, {...contactlink.dataset}).mount(contactlink);
    });
}
if (breadcrumbs) {
    breadcrumbs.forEach((breadcrumb) => {
        createApp(Breadcrumbs, {...breadcrumb.dataset}).mount(breadcrumb);
    });
}

if (devgrid) {
    createApp(DevGrid, {...devgrid.dataset}).mount(devgrid);
}